import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: "https://f62cfc8c43d65639cc65dd7ec9658385@o35671.ingest.us.sentry.io/4509949739532288",
    
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
    sendDefaultPii: true,
    enableLogs: true,
});